import Sign from "@/views/editor/service/sign/sign/index";
import {INewBusiness} from "@/views/editor/service/business";

export default {'sign': Sign} as { [key: string]: INewBusiness }